import { render, staticRenderFns } from "./ValidaCandidato.vue?vue&type=template&id=d5145ebe"
import script from "./ValidaCandidato.vue?vue&type=script&lang=js"
export * from "./ValidaCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports